export const environment = {
  production: true,
  base_url: 'https://colegioadmin.com.ar/api',
  afipUrl:  'https://colegioadmin.com.ar', 
  back_url: 'https://colegioadmin.com.ar'
};
